<script>
    import MapX2 from "./MapX2.svelte";
    export let x;
    export let y;
    export let width;
    export let height;
    export let els;
    export let sub;

    let tx = 0;
    let ty = 0;
    let scale = 1;
    let cw = 0;
    let ch = 0;
    let rtx = 0;
    let rty = 0;
    let rscale = 0;
    let btx = 0;
    let bty = 0;
    let bscale = 0;
    let beginTime = 0;
    let endTime = 0;
    let isAnim = false;

    let stepScale;
    let vl;

    $: {
        if (scale <= 1) {
            stepScale = 1;
        }
        else if (scale <= 2) {
            stepScale = 2;
        }
        else if (scale <= 4) {
            stepScale = 4;
        }
        else if (scale <= 8) {
            stepScale = 8;
        }
        else if (scale <= 16) {
            stepScale = 16;
        }
        else if (scale <= 32) {
            stepScale = 32;
        }
    }

    $: vl = scale < 3 ? 0 : scale < 9 ? 1 : scale < 17 ? 2 : 3;


    document.onmousedown = press => {
        press.preventDefault();

        document.onmousemove = move => {
            tx = rtx = tx + (move.screenX - press.screenX);
            ty = rty = ty + (move.screenY - press.screenY);
            move.preventDefault();
        }

        document.onmouseup = up => {
            document.onmousemove = null;
            document.onmouseup = null;
            up.preventDefault();
        }
    }

    document.onwheel = wheel => {
        let step = stepScale;
        let cscale = rscale || scale;
        let ctx = rtx || tx;
        let cty = rty || ty;
        let nscale;

        if (wheel.deltaY < 0) {
            let v = cscale + 0.1 * step;

            if (v < 32) {
                nscale = v;
            }
            else {
                nscale = 32;
            }
        }
        else {
            let v = cscale - 0.1 * step;

            if (v > 0.5) {
                nscale = v;
            }
            else {
                nscale = 0.5;
            }
        }

        animTo(
            ctx - (nscale - cscale) * (wheel.clientX - ctx) / cscale,
            cty - (nscale - cscale) * (wheel.clientY - cty) / cscale,
            nscale
        );
    }

    window.onkeypress = () => {
        document.onwheel({deltaY: -1, clientX: 0, clientY: 0});
    }

    window.onresize = () => {
        cw = window.innerWidth;
        ch = window.innerHeight;
    }

    window.onresize();

    function animTo (x, y, scale1) {
        rtx = x;
        rty = y;
        rscale = scale1;
        btx = tx;
        bty = ty;
        bscale = scale;

        beginTime = new Date().getTime();
        endTime = beginTime + 300;

        if (!isAnim) {
            isAnim = true;

            let update = () => {
                let now = new Date().getTime();

                if (now > endTime) {
                    isAnim = false;
                    tx = rtx;
                    ty = rty;
                    scale = rscale;
                }
                else {
                    let progress = (now - beginTime) / 300;
                    let step = Math.cos(Math.PI * progress) - 1;

                    tx = -(rtx - btx) / 2 * step + btx;
                    ty = -(rty - bty) / 2 * step + bty;
                    scale = -(rscale - bscale) / 2 * step + bscale;

                    window.requestAnimationFrame(update);
                }
            };

            window.requestAnimationFrame(update);
        }
    }
</script>

<div
        class="map x{stepScale}"
        style="
        width: {stepScale === 1 ? width : 0}px;
        height: {stepScale === 1 ? height : 0}px;
        transform: {stepScale === 1 ? 'translate(' + (x + tx) + 'px, ' + (y + ty) + 'px) scale(' + scale + ')' : ''};
        position: {stepScale === 1 ? 'absolute' : 'static'};
        will-change: {stepScale === 1 ? 'transform' : ''};
      "
>
    {#each sub as item}
    <MapX2
            bind:x={item.x}
            bind:y={item.y}
            bind:width={item.width}
            bind:height={item.height}
            bind:els={item.els}
            bind:sub={item.sub}
            bind:tx={tx}
            bind:ty={ty}
            bind:scale={scale}
            bind:cw={cw}
            bind:ch={ch}
            bind:stepScale={stepScale}
            bind:vl={vl}
    />
    {/each}
</div>
